import PhotoCapture from 'components/SmartSkinScan/PhotoCapture/PhotoCapture';
import { withPhotoCaptureProps } from 'viewModel/smartSkinScan/withPhotoCaptureProps';

export default withPhotoCaptureProps(PhotoCapture);
